import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { PalletType } from "@/app/services/generated/pallettypeService";
import { palletTypeService } from "@/app/services/generated/pallettypeService";

export interface IHasPalletTypesCache {
  palletTypes: PalletTypesCache;
}
// Singleton cache store
const palletTypesCacheStore = new EntityCacheStore<PalletType>(
  EnumCacheEntityType.palletType,
  async () => palletTypeService.getAllPalletTypes()
);

// Ephemeral reader
export default class PalletTypesCache extends EntityWithGuidKeyCache<PalletType> {
  constructor() {
    super(palletTypesCacheStore, (x) => x.id);
  }

  getDefault() {
    return this.allReactive.value.find((palletType) => palletType.isDefault);
  }
}
